import React from 'react';
import {useSelector} from 'react-redux';
import {Routes, Route} from 'react-router-dom';
import LayoutFeature from '../layout/layout-feature';
import PublicRoutesFeature from './public-routes-feature';
import unauthenticatedRoutes from '../../routes/unauthenticated.routes';

function UnauthenticatedRoutesFeature() {
  const auth = useSelector(state => state.auth);
  const routes = unauthenticatedRoutes(auth);

  return (
    <Routes>
      <Route key="unauthenticated-layout" element={<LayoutFeature />}>
        {routes.map(({slug, path, Component}) => (
          <Route path={path} key={slug} element={<Component />} />
        ))}
      </Route>
      <Route path="/*" element={<PublicRoutesFeature />} />
    </Routes>
  );
}

export default UnauthenticatedRoutesFeature;
